import { required, minLength, email } from 'vuelidate/lib/validators';
import { NAME_REGEXP, MOBILE_PHONE_REGEXP } from '../constants/constants';
import isTrue from '../validators/is-true';
import pattern from '../validators/pattern';
export default {
	validations() {
		let validationObj = {
			model: {
				name: {
					required,
					minLength: minLength(5),
					pattern: pattern(NAME_REGEXP)
				},
				email: {
					required,
					email
				},
				phoneNumber: {
					required,
					pattern: pattern(MOBILE_PHONE_REGEXP)
				},
				time: {
					required
				}
			},
			captchaError: {
				isTrue
			}
		};
		if (this.captcha && this.captcha.htmlFragment) {
			validationObj.model.captcha = {
				required
			};
		}
		return validationObj;
	},
};
